<template>
  <div>
    <div
      class="content-devx"
      style="margin-bottom: 1.5rem;"
    >
      <span class="dx-form-group-caption">{{ 'PROYECTO' }}</span>
      <f7-block class="content">
        <f7-row
          v-for="(item, index) in completeList"
          :key="index"
        >
          <f7-col class="projects">
            {{ item.name }}
          </f7-col>
          <f7-col class="actions">
            <div
              class="tooltip-custom"
              @click="editProject(item)"
            >
              <f7-icon
                class="icon-menu edit-project-icon"
                width="32"
                height="32"
              />
              <span class="tooltip-text-custom">Ver y/o Editar Proyecto</span>
            </div>
            <div
              class="tooltip-custom"
              @click="goToResult(item)"
            >
              <f7-icon
                class="icon-menu results-icon"
                width="32"
                height="32"
              />
              <span class="tooltip-text-custom">Resultados</span>
            </div>
            <div
              class="tooltip-custom"
              @click="deleteProject(item)"
            >
              <f7-icon
                class="icon-menu delete-icon"
                width="32"
                height="32"
              />
              <span class="tooltip-text-custom">Eliminar Proyecto</span>
            </div>
          </f7-col>
        </f7-row>
      </f7-block>
    </div>

    <div
      v-if="demoList.length"
      class="content-devx"
      style="margin-bottom: 1.5rem;"
    >
      <span class="dx-form-group-caption">{{ 'PROYECTO' }}</span>
      <f7-block class="content">
        <f7-row
          v-for="(item, index) in demoList"
          :key="index"
        >
          <f7-col class="projects">
            {{ item.name }}
          </f7-col>
          <f7-col class="actions">
            <div
              class="tooltip-custom"
              @click="editProject(item)"
            >
              <f7-icon
                class="icon-menu edit-project-icon"
                width="32"
                height="32"
              />
              <span class="tooltip-text-custom">Ver Proyecto</span>
            </div>
            <div
              class="tooltip-custom"
              @click="goToResult(item)"
            >
              <f7-icon
                class="icon-menu results-icon"
                width="32"
                height="32"
              />
              <span class="tooltip-text-custom">Resultados</span>
            </div>
          </f7-col>
        </f7-row>
      </f7-block>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EventBus from '../../../js/event-bus';

export default {
  name: 'DxListGh',
  components: {
  },
  props: {
    listGh: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      demoList: [],
      completeList: [],
    };
  },
  computed: {
    ...mapState('Result', ['resultProject']),
    ...mapState('Database', ['currentProject']),
  },
  mounted() {
    if (this.listGh && this.listGh.length) {
      this.demoList = [];
      this.completeList = [];
      this.listGh.forEach((item) => {
        if (item.id === '6266cb565842a56069a46607') {
          this.demoList.push(item);
        } else {
          this.completeList.push(item);
        }
      });
    }
  },
  methods: {
    projectSelected(e) {
      if (typeof e.event !== 'undefined') {
        this.setCurrentProject(e.value);
        this.getProjectWithId(e.value);
        this.$f7.views.main.router.navigate('/pageRegisterProject/');
      }
    },
    async callToDeleteProject(rowSelected) {
      this.$f7.preloader.show();
      try {
        await this.deleteProject(rowSelected);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async editProject(rowSelected) {
      try {
        this.$f7.preloader.show();
        this.setCurrentProject(rowSelected.id);
        await this.getProjectWithId(rowSelected.id);
        this.$f7.views.main.router.navigate('/pageViewProject/');
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async goToResult(rowSelected) {
      try {
        this.$f7.preloader.show();
        await this.loadResult(rowSelected.id);
        if (this.resultProject.status === 'OK' || this.resultProject.status === null) {
          this.$f7.views.main.router.navigate('/tabs-result/');
        } else if (this.resultProject.status === 'GEN') {
          this.$f7.dialog
            .alert('Por favor espere un momento y vuelva a intentar, el sistema sigue calculando el resultado.');
        } else if (this.resultProject.error_message && this.resultProject.error_message !== '') {
          this.$f7.dialog
            .alert(this.resultProject.error_message);
        } else {
          this.$f7.dialog.alert('¡Upss ha ocurrido un error! Por favor verifique sus datos.');
        }
      } catch (error) {
        this.$f7.dialog.alert('Ha ocurrido un error');
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async deleteProject(rowSelected) {
      this.$f7.preloader.show();
      try {
        await this.deleteProjectWithId(rowSelected.id);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
        EventBus.$emit('fetch-projects');
      }
    },
    ...mapActions('Database', ['setCurrentProject']),
    ...mapActions('ProjectGreenHouse', ['getProjectWithId', 'deleteProjectWithId']),
    ...mapActions('Result', ['loadResult']),
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 1rem;
}
.projects {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 140%;
  background: #FFFFFF;
  padding: 10px;
  border: 1px solid #C0C9CE;
  box-sizing: border-box;
  border-radius: 5px;
}
.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px;
  border-radius: 5px;
  &:hover {
    background: #F4F8FA;
  }
}
.actions {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  align-items: center;
  align-content: center;
}
.icon-btn {
  border: none;
  background: transparent;
}
.icon-menu {
  width: 24px;
  height:24px;
  cursor: pointer;
}
.edit-project-icon{
  content: url("../../../static/icons/Editar.svg");
}
.delete-icon{
  content: url("../../../static/icons/Eliminar.svg");
}
.results-icon{
  width: 20px;
  content: url("../../../static/icons/Results.svg");
}
</style>
